import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalkingMan = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Groupe_447",
		"data-name": "Groupe 447",
		transform: "translate(-143.373 -43.557)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Trac\\xE9_202",
			"data-name": "Trac\\xE9 202",
			d: "M178.384,59.737a3.712,3.712,0,0,0-2.552-1.468l-4.1-.485a4.444,4.444,0,0,0-.8-1.545,4.4,4.4,0,1,0-5.6-1.613c-.243.024-.487.049-.727.089l-4.265.7a3.808,3.808,0,0,0-3.013,2.612l-1.651,4.81a3.771,3.771,0,0,0,2.465,4.664A3.732,3.732,0,0,0,161,67.252a3.692,3.692,0,0,0,1.83-2.147l.983-2.662.614-.1v3.524L162.9,70.928l-2.81,1.475a3.732,3.732,0,1,0,3.487,6.6l3.795-2.019a4.656,4.656,0,0,0,1.827-1.756l.476,2.438a3.738,3.738,0,1,0,7.338-1.434L175.778,69.9a1.193,1.193,0,0,0-.421-.692l-3.447-3.448v-.415l3.041.36a3.681,3.681,0,0,0,.448.027,3.745,3.745,0,0,0,2.985-6Zm-9.342-9.48a2.016,2.016,0,1,1-2.016,2.017A2.019,2.019,0,0,1,169.042,50.257Zm-1.785,23.552a2.27,2.27,0,0,1-1,1.07L162.459,76.9a1.349,1.349,0,1,1-1.261-2.385l3.252-1.708a1.19,1.19,0,0,0,.587-.709l.386-1.275,1.986,1.636Zm6.256-3.073,1.163,5.951a1.356,1.356,0,1,1-2.661.52l-.914-4.68a1.186,1.186,0,0,0-.361-.647l-3.924-3.62V60.953a1.191,1.191,0,0,0-1.377-1.177l-2.681.423a1.193,1.193,0,0,0-.931.764l-1.244,3.37a1.374,1.374,0,0,1-2.637-.766l1.651-4.81a1.429,1.429,0,0,1,1.131-.992l4.265-.7a9.129,9.129,0,0,1,1.471-.12h1a2.069,2.069,0,0,1,2.067,2.067v7.243a1.192,1.192,0,0,0,.349.842Zm3.224-8.527a1.359,1.359,0,0,1-1.505,1.132l-3.091-.366V60.232l3.411.4a1.363,1.363,0,0,1,1.185,1.574Z",
			transform: "translate(-4.911 -1.573)",
			fill: "#3f838a"
		}), /* @__PURE__ */ _jsx("g", {
			id: "Groupe_77",
			"data-name": "Groupe 77",
			transform: "translate(143.373 43.985)",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_20",
				"data-name": "Rectangle 20",
				width: 38,
				height: 38,
				transform: "translate(0 -0.427)",
				fill: "none"
			})
		})]
	})]
});
const ForwardRef = forwardRef(SvgWalkingMan);
export { ForwardRef as ReactComponent };
